import { sort, descend, find, last } from 'ramda';
import { connect } from 'react-redux';
import type { RequireAtLeastOne } from '@peloton/types';
import type { ResponsiveSelectorState, Breakpoint } from './reducer';
import { getIsBreakpointGreaterThan } from './reducer';

const largestApplicableBreakpoint = (
  state: ResponsiveSelectorState,
  breakpoints: Breakpoint[],
) => {
  const orderedBreakpoints = sort(
    descend<Breakpoint>(b => state.browser.breakpoints[b]),
    breakpoints,
  );
  const match = find(b => getIsBreakpointGreaterThan(state, b), orderedBreakpoints);
  // asserting because of the RequireAtLeastOneType
  return match || last(orderedBreakpoints)!;
};

export default <Props>(propMap: RequireAtLeastOne<Record<Breakpoint, Props>>) =>
  connect((state: ResponsiveSelectorState) => {
    const match = largestApplicableBreakpoint(
      state,
      Object.keys(propMap) as Breakpoint[],
    );

    return propMap[match];
  });
